import { infoCard } from './infoCard.js';
import { tabSwitch } from './tabSwitch.js';
import { contactForm } from './contactForm.js';
import { priceCalculator } from './priceCalculator.js';
import { inputArrows } from './inputArrows.js';
import { plans } from './plansData.js';

export const initCalc = () => {
    tabSwitch.setElements();
    infoCard.setElements();
    contactForm.setElements();

    tabSwitch.init();
    priceCalculator();
    inputArrows();
    infoCard.init();
    contactForm.init();

    const planFromParams = new URLSearchParams(location.search).get('plan');
    if (plans[planFromParams]) {
        tabSwitch.changeTab(planFromParams);
        if (planFromParams == 'enterprise') {
            contactForm.formElem.classList.remove('hide');
            contactForm.hintBtn.classList.add('hide');
        }
    }
};
